<template>
    <BasicLayouts>
        <div class="ui grid">
            <div 
                class="sixten wide mobile eight wide tablet four wide computer column"
                v-for="product in products" :key="product.id"
            >
                <product :product="product" />
            </div>
        </div>
    </BasicLayouts>
</template>

<script>
import { ref,onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getCategoriesApi,getProductsCategory } from '../api/product';
import Product from '../components/Product.vue';
import BasicLayouts from '../layouts/BasicLayouts.vue';
export default {
    name:'Category',
    components:{
        BasicLayouts,
        Product
    },

    watch:{
        $route(to,from){
            this.getProducts(to.params.category);
        },
    },

    setup(){
        let products= ref(null);
        const { params } = useRoute(); 

        onMounted(()=>{
            getProducts(params.category);
        });

        const getProducts= async (category) =>{
            const response= await getProductsCategory(category);
            products.value= response;
        }; 
        return{
            getProducts,
            products,
        };
    },
};
</script>
